var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "breadcrumb-con" }, [
        _c("div", { staticStyle: { display: "inline-flex", float: "left" } }, [
          _c("a", { on: { click: _vm.toRobotList } }, [
            _c("i", { staticClass: "el-icon-arrow-left back-icon" })
          ]),
          _vm._v(" "),
          _vm.chatbotDetail && _vm.chatbotDetail.logo
            ? _c("img", {
                staticClass: "chatbot-logo",
                attrs: { src: _vm.chatbotDetail.logo }
              })
            : _c("img", {
                staticClass: "chatbot-logo",
                attrs: { src: require("../assets/robot.png") }
              }),
          _vm._v(" "),
          _c("div", { staticClass: "breadTitle" }, [
            _vm._v(
              _vm._s(
                (_vm.chatbotDetail && _vm.chatbotDetail.name) ||
                  _vm.formatMessage({
                    id: "5g.message.h5.components.chat",
                    defaultMessage: "聊天"
                  })
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "returnLogin", on: { click: _vm.toLogin } }, [
          _vm._v(
            _vm._s(
              _vm.formatMessage({
                id: "5g.message.h5.login",
                defaultMessage: "登录"
              })
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "ul",
        {
          ref: "historyList",
          staticClass: "tutorial-page",
          style: {
            height: _vm.showActionIcon
              ? "calc(100% - 138px)"
              : "calc(100% - 108px)"
          },
          attrs: { id: "historyList" }
        },
        _vm._l(_vm.recordList, function(item, index) {
          return _c(
            "li",
            {
              key: item.createTime,
              staticStyle: { "list-style": "none" },
              attrs: { tid: "createTime" }
            },
            [
              item.messageSource == "chatbot"
                ? _c("div", { staticClass: "content-item" }, [
                    _c("div", { staticClass: "left" }, [
                      _c(
                        "div",
                        { staticClass: "left-line" },
                        [
                          _c("template-card", {
                            attrs: {
                              "data-source": item,
                              "show-btn":
                                index == _vm.recordList.length - 1 ||
                                (_vm.diverLineIndexIsLast &&
                                  index == _vm.recordList.length - 2)
                            },
                            on: { clickLink: _vm.rcsHandleClick }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatTime-left" }, [
                      _vm._v(_vm._s(_vm.getCreateTime(item.createTime)))
                    ])
                  ])
                : item.messageSource == "user"
                ? _c("div", { staticClass: "content-item" }, [
                    _c("div", { staticClass: "right" }, [
                      _c("img", {
                        staticClass: "header-user",
                        attrs: { src: require("../assets/user.png") }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "right-line" },
                        [
                          _c("message-type", { attrs: { "data-source": item } })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "chatTime-right" }, [
                      _c("span", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.getCreateTime(item.createTime)))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "type" }, [
                        _vm._v(_vm._s(item.sendType))
                      ])
                    ])
                  ])
                : _vm.recordList.length > 1
                ? _c("div", { staticClass: "diver-line" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatMessage({
                            id: "5g.message.h5.chatRoom.hismsg",
                            defaultMessage: "以上为历史消息"
                          })
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "bottom-input",
          style: { height: _vm.showActionIcon ? "60px" : "30px" }
        },
        [
          _vm.showActionIcon
            ? _c(
                "div",
                { staticClass: "bottom-row" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        accept: "image/*",
                        "show-file-list": false,
                        action: _vm.uploadFileUrl,
                        "on-success": _vm.uploadFileImage,
                        "on-error": _vm.uploadFileError
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "left-icon",
                        attrs: { src: require("../assets/photo.png") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        accept: "video/*",
                        "show-file-list": false,
                        action: _vm.uploadFileUrl,
                        "on-success": _vm.uploadFileVideo,
                        "on-error": _vm.uploadFileError
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "left-icon",
                        attrs: { src: require("../assets/video.png") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "left-icon",
                    attrs: { src: require("../assets/videoCall.png") },
                    on: { click: _vm.toVideoCall }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "left-icon",
                    attrs: { src: require("../assets/location.png") },
                    on: {
                      click: function($event) {
                        _vm.dialogVisible = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bottom-row" },
            [
              _vm.showMenu && _vm.menuList.length > 0
                ? _c("img", {
                    staticClass: "left-icon",
                    attrs: { src: require("../assets/keyboard.png") },
                    on: { click: _vm.toggleShowMenu }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showMenu && _vm.menuList.length > 0
                ? _c("img", {
                    staticClass: "left-icon",
                    attrs: { src: require("../assets/menu.png") },
                    on: { click: _vm.toggleShowMenu }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showMenu || _vm.menuList.length == 0
                ? _c("img", {
                    staticClass: "left-icon",
                    attrs: { src: require("../assets/extraIcon.png") },
                    on: { click: _vm.toggleShowIcon }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showMenu || _vm.menuList.length == 0
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputValue,
                        expression: "inputValue"
                      }
                    ],
                    staticClass: "el-input__inner innerInput",
                    style: {
                      marginLeft: _vm.menuList.length > 0 ? "0px" : "8px"
                    },
                    attrs: {
                      placeholder: _vm.formatMessage({
                        id: "5g.message.h5.common.name.plsinput",
                        defaultMessage: "请输入内容"
                      })
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.inputValue = $event.target.value
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showMenu || _vm.menuList.length == 0
                ? _c(
                    "el-button",
                    {
                      staticClass: "send-btn",
                      on: { click: _vm.sendTextMessage }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formatMessage({
                            id: "5g.message.h5.chatRoom.send",
                            defaultMessage: "发送"
                          })
                        )
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu && _vm.menuList.length > 0
                ? _c(
                    "div",
                    { staticClass: "menu-con" },
                    [
                      _vm._l(_vm.menuList, function(menu) {
                        return [
                          menu.menu
                            ? _c(
                                "el-dropdown",
                                {
                                  staticClass: "menu-item",
                                  attrs: {
                                    id: "menu.menu.displayText",
                                    trigger: "click"
                                  },
                                  on: { command: _vm.handleCommand }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        width: "100%"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(menu.menu.displayText) +
                                          "\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      staticClass: "pop-menu",
                                      attrs: {
                                        slot: "dropdown",
                                        placement: "top-start"
                                      },
                                      slot: "dropdown"
                                    },
                                    _vm._l(menu.menu.entries, function(
                                      subMenu,
                                      index
                                    ) {
                                      return _c(
                                        "el-dropdown-item",
                                        {
                                          key: index,
                                          attrs: { command: subMenu }
                                        },
                                        [
                                          subMenu.action
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "pop-menu-item"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      subMenu.action.displayText
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          subMenu.reply
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "pop-menu-item"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      subMenu.reply.displayText
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          menu.action
                            ? _c(
                                "div",
                                {
                                  staticClass: "menu-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleMenuClick(menu, "Menu")
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(menu.action.displayText))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          menu.reply
                            ? _c(
                                "div",
                                {
                                  staticClass: "menu-item",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleMenuClick(menu, "Menu")
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(menu.reply.displayText))]
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "currerntMap" } }),
      _vm._v(" "),
      _vm.dialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                "custom-class": "custom-dialog",
                fullscreen: true,
                title: null,
                "show-close": false,
                top: "0",
                visible: _vm.dialogVisible,
                width: "100%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c("map-location", {
                on: {
                  cancle: function($event) {
                    _vm.dialogVisible = false
                  },
                  sendLocation: _vm.handleSendLocation,
                  updateCurrentLocation: _vm.updateCurrentLocation
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.webFrameVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                "custom-class": "custom-dialog",
                fullscreen: true,
                title: null,
                "show-close": true,
                top: "0",
                visible: _vm.webFrameVisible,
                width: "100%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.webFrameVisible = $event
                }
              }
            },
            [
              _c("web-container", {
                attrs: { webUrl: _vm.webReallyUrl },
                on: {
                  goback: function($event) {
                    _vm.webFrameVisible = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d288eda2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d288eda2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/chatRoom/index.vue
// module id = null
// module chunks = 